import { FunctionComponent } from 'react';
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker';
import { TextField, TextFieldProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

type DatePicker = {
    label: string;
    onChange: (date: Date | null) => void;
    value: Date | null;
    disabled?: boolean;
    disablePast?: boolean;
    textFieldProps?: TextFieldProps;
};

export const DatePicker: FunctionComponent<DatePicker> = ({
    onChange,
    label,
    value,
    disabled = false,
    disablePast = false,
    textFieldProps = {},
}) => {
    const { t } = useTranslation();
    return (
        <MuiDatePicker<Date>
            label={label}
            inputFormat='dd.MM.yyyy'
            value={value}
            onChange={onChange}
            renderInput={(params) => {
                const { inputProps, ...textFieldParams } = params;
                return (
                    <TextField
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        {...(textFieldParams as any)}
                        inputProps={{
                            ...(inputProps as Record<string, unknown>),
                            placeholder: t('datePickerPlaceholder'),
                        }}
                        {...textFieldProps}
                        fullWidth
                        sx={[
                            {
                                '& .MuiInputBase-input': {
                                    paddingRight: '40px',
                                },
                            },
                            textFieldProps.sx,
                        ]}
                    />
                );
            }}
            disablePast={disablePast}
            disabled={disabled}
        />
    );
};
